import { useState, useRef, useCallback, useEffect } from 'react';
import { TIMER_DURATION, OTP_LENGTH } from '../constants';

export const useOTP = () => {
  const [otp, setOtp] = useState(Array(OTP_LENGTH).fill(''));
  const [timer, setTimer] = useState(TIMER_DURATION);
  const [otpError, setOtpError] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const otpInputRefs = useRef([]);

  const handleOtpChange = useCallback((index, value) => {
    // Only allow numeric input
    if (!/^\d*$/.test(value)) return;
    if (value.length > 1) return;

    setOtp((prev) => {
      const newOtp = [...prev];
      newOtp[index] = value;
      return newOtp;
    });

    if (value && index < OTP_LENGTH - 1) {
      otpInputRefs.current[index + 1]?.focus();
    }
  }, []);

  const handleOtpKeyDown = useCallback(
    (index, e) => {
      if (e.key === 'Backspace' && !otp[index] && index > 0) {
        otpInputRefs.current[index - 1]?.focus();
      }
    },
    [otp]
  );

  const handleOtpPaste = useCallback((e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, OTP_LENGTH);
    const newOtp = Array(OTP_LENGTH).fill('');

    pastedData.split('').forEach((char, index) => {
      if (index < OTP_LENGTH) {
        newOtp[index] = char;
      }
    });

    setOtp(newOtp);
    otpInputRefs.current[Math.min(pastedData.length, OTP_LENGTH - 1)]?.focus();
  }, []);

  const resetOTP = useCallback(() => {
    setOtp(Array(OTP_LENGTH).fill(''));
    setTimer(TIMER_DURATION);
    setOtpError('');
  }, []);

  // Timer countdown
  useEffect(() => {
    let interval = null;
    if (isModalOpen && timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [isModalOpen, timer]);

  return {
    otp,
    timer,
    otpError,
    isModalOpen,
    otpInputRefs,
    setOtp,
    setTimer,
    setOtpError,
    setIsModalOpen,
    handleOtpChange,
    handleOtpKeyDown,
    handleOtpPaste,
    resetOTP,
  };
};
